import { Injectable } from '@angular/core'

import { PricingPlanFeatureMap, PricingPlans } from '@ti/contracts'
import { BasePricingPlanService } from '@ti/core/common/services/pricing-plan.service'

// Service used in TSP to ignore Fleet pricing plan checks
@Injectable()
export class StubHighestPricingPlanService extends BasePricingPlanService {
  protected async getUserPlanFeatures() {
    return PricingPlanFeatureMap[PricingPlans.Premium]
  }
}
